import { defineQuartzConfig } from 'quartz-config';
const logFetchErrorsOptions = {
  ignoreErrors: ['I18n failed to parse api-verify data: undefined', 'Illegal invocation', /Object Not Found Matching Id:\d*/, /Loading chunk .* failed\./i, /Loadable: error loading split chunk/i, /dlb .*bundle.production.js not loaded/i, /Database deleted by request of the user/i],
  shouldSendCallback: () => !/Amazonbot/i.test(navigator.userAgent)
};
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  htmlTitle: '',
  i18n: {
    mode: 'lazy'
  },
  historyBasename: '/documents/:portalId',
  // Fast refresh breaks pdf.js worker, toggle to `true` if encountering injection issues locally with $RefreshSig$
  disableFastRefresh: false,
  initialPageLoadTracking: true,
  sessionResourceTracking: true,
  logFetchErrors: {
    options: logFetchErrorsOptions
  },
  createRootApi: true
});